<div class="mt-5 px-3" *ngIf="currentTab==='publish' && publishPermission">
  <h2 class="font-5x font-bold">Publish</h2>
  <div class="block__dark text-center mt-4">
    <p>Click on the button below, only if you are 100% sure that you want to {{preventEdit ? 'unpublish': 'publish'}}
      the
      {{option}}.
    </p>
    <div class="row justify-content-center">
      <div class="d-flex justify-content-center align-items-center">
        <div class="pr-4 pt-2">
          <div class="custom-control custom-checkbox text-left">
            <input type="checkbox" class="custom-control-input" id="isNotification" [(ngModel)]="notificationChecked">
            <label class="custom-control-label pl-1" id="isNotificationLabel" for="isNotification">
              Send notifications to all the users                        
            </label>
          </div>
        </div>    
        <div class="uf-publish-btnwrap"> 
                <button type="button"  class="btn btn-primary btn-block uf-publish-btn " id="publishBtn" data-toggle="modal"
                  [disabled]="!dataArrived"
                  data-target="#publishModal" [hidden]="preventEdit">Publish<span class="sr-only">(Opens in a new
                    dialog)</span></button>
                <button class="btn btn-primary btn-block uf-publish-btn" id="unpublishBtn" *ngIf="preventEdit"
                  [disabled]="!dataArrived && !canUnpublishTaxonomy" (click)="unpublishTaxonomy()" data-toggle="modal">Unpublish<span
                    class="sr-only"> (Opens in a new dialog) </span></button>
        </div>              
       </div>
    </div>

  </div>
</div>


<ng-container *ngIf="currentTab==='export' || currentTab==='exportCurriculam'">
  <ng-container *ngIf="showIcon">
    <button type="button" class="btn btn-clear font-bold d-flex align-items-center" id="expoetPacingGuideBtn" data-toggle="modal"
      data-target="#expoetPacingGuide" (click)="onExportModalOpen()">
      <em class="material-icons-outlined pr-2" aria-hidden="true">file_download</em> Download
    </button>
  </ng-container>

  <ng-container *ngIf="!showIcon">
    <h2 class="font-5x font-bold">Export</h2>
    <div class="block__dark text-center mt-4">
      <p>Click on the button below to Export the Taxonomy in various export format.</p>
      <div class="row justify-content-center">
        <div class="col-sm-3">
          <button class="btn btn-primary btn-block" id="expoetPacingGuideBtn"
            *ngIf="currentTab==='export' && exportPermission" data-target="#expoetPacingGuide"
            (click)="onExportModalOpen()" data-toggle="modal">Export</button>

        </div>
      </div>

    </div>
  </ng-container>
</ng-container>


<!-- Publish modal -->
<app-modal [modalId]="'publishModal'" [modalContentId]="'publishModalContent'" [showCancelBtn]="false"
  [modalSize]="'big'" (closeEvent)="closePublish()">
  <modal-div class="title-text" id="publishtitle">
    Publish
  </modal-div>

  <modal-div class="body-content">
    <div id="publishModalContent" class="pb-1">
      <p class="modal--info-txt font-bold mb-2">You are trying to publish taxonomy "{{taxonomyTitle}}".</p>
      <p class="modal--info-txt font-bold">Looks like the taxonomy has some issues. We recomend you review the list
        below and do the needful before you publish.</p>
    </div>

    <div class="col-12 panel" *ngIf="!isOnlyExport">
      <app-taxonomy-compliance-report [viewLocation]="'publish'" class="w-100" (caseData)="getCaseData($event);"
        (coverageData)="getCoverageData($event);" [taxonomyId]="taxonomyId"></app-taxonomy-compliance-report>
    </div>

    <div class="row mt-5">
      <div class="col-5">
        <h3 class="mb-0">Project Status</h3>
        <app-data-table class="w-100" [showMenu]="false" [tableCategory]="'associated Projects'"
          [showLoader]="publishLoader" [columnList]="listOfColumn" [dataSet]="associatedProjects"></app-data-table>
      </div>

      <div class="col-7">
        <div class="row mt-5">
          <div class="col-4 pl-0">
            <!-- drop-down for options to publish taxonomy -->
            <label for="select{{selectedCASEstatus}}" id="casestatusLabel">CASE Status</label>
            <select class="form-control custom-select" id="select{{selectedCASEstatus}}"
              [(ngModel)]="selectedCASEstatus" [disabled]="!caseStatusPermission">
              <option value="2" id="draft">Draft</option>
              <option value="3" id="adopted">Adopted</option>
              <option value="4" id="deprecated">Deprecated</option>
            </select>
          </div>
          <div class="col-4 p-r">
            <label for="versionTag">Version Label</label>
            <input type="text" class="form-control" id="versionTag" [(ngModel)]="publishVersionTag">
          </div>
          <div class="col-12 mt-2 custom-control custom-checkbox"
            *ngIf="copyTaxonomyObj && copyTaxonomyObj.publishNumber === ''">
            <input type="checkbox" id="allowNotificationOption" class="custom-control-input"
              [(ngModel)]="sendNotification">
            <label for="allowNotificationOption" class="custom-control-label">Send notifications to the subscribers of
              {{copyTaxonomyObj.originalTaxonomy}}</label>
          </div>
        </div>

        <div class="mt-4">
          <ng-container *ngIf="unMappedNodes && unMappedNodes.length > 0">
            <h3 class="modal-title--secondary font-bold mb-0">Unassigned Nodes</h3>
            <p>Here is a list of nodes that are not assigned to any project.</p>

            <ol class="mb-0">
              <li *ngFor="let node of unMappedNodes">{{node.value}}</li>
            </ol>

          </ng-container>
        </div>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button class="btn btn-clear text-underline" id="publishtaxoBtn" (click)="publishTaxonomy($event)"
      *ngIf="caseDataPercent!== 100 ||  coverageDataPercent !== 100 || unMappedNodes.length !==0 || !project_status">
      I Want to Publish the taxonomy with the issues.</button>
    <button type="button" class="btn btn-primary btn-lg" id="publishedtaxoBtn" (click)="publishTaxonomy($event)"
      *ngIf="caseDataPercent === 100 &&  coverageDataPercent === 100 && unMappedNodes.length ===0 && project_status">
      Publish Taxonomy {{taxonomyTitle}}</button>
  </modal-div>
</app-modal>




<!-- Export Modal Starts -->
<app-modal [modalId]="'expoetPacingGuide'" [showCloseAlert]="false" [modalSize]="'small'" (closeEvent)="onCancel()"
  [showHelp]="false">
  <modal-div class="title-text" id="{{option}}title">
    Export {{option}}
  </modal-div>

  <modal-div class="body-content">
    <div class="row">
      <div class="col-12 p-0">
        <p class="pl-3 pt-3">Fields marked with an asterisk (<span class="mandatory">*</span>) is
          required.</p>
        <form [formGroup]="form">
          <div class="form-group col-lg-12 col-sm-12">
            <label for="exportFormat" class="font-bold" id="exportFormatLabel">Export Format <span
                class="mandatory">*</span></label>
            <select *ngIf="dropdownList.length === 0" class="custom-select form-control" id="exportFormat" name="role"
              formControlName="file_format" [(ngModel)]="selectedFileType" aria-labelledby="exportFormatLabel">
              <option [ngValue]="null" id="sel-0">Select format</option>
              <option [ngValue]="'JSON_WITHOUT_FORMATTED'" id="sel-2">JSON</option>
              <option [ngValue]="'JSON_WITH_CUSTOM'" id="sel-3">JSON With Custom</option>
              <option *ngIf="exportCSV" [ngValue]="'CSV'" id="sel-4">CSV</option>
              <option [ngValue]="'PDF'" id="sel-5">PDF</option>
              <option *ngIf="isCustomView" [ngValue]="'CUSTOM_PDF'" id="sel-6">Custom View PDF</option>
              <option *ngIf="isCustomView" [ngValue]="'DOCX'" id="sel-7">Custom View DOC</option>
              <option *ngIf="canExportXML" [ngValue]="'XML'" id="sel-8">Goal XML (Blackboard)</option>
              <option 
                *ngIf="isFontFacing && currentTab !== 'export' && !fullTaxonomy"
                [ngValue]="'FILTERED_PDF'"
                id="sel-9">
                  FILTERED PDF
              </option>
            </select>
            <select *ngIf="dropdownList.length" class="custom-select form-control" id="exportFormat" name="role"
              formControlName="file_format" [(ngModel)]="selectedFileType" aria-labelledby="exportFormatLabel">
              <option [ngValue]="null" id="sel-0">Select format</option>
              <option *ngFor="let item of dropdownList; let i = index" [ngValue]="item" id="sel-{{i+1}}">
                {{item}}
              </option>
              <option
                *ngIf="isFontFacing && currentTab !== 'export' && !fullTaxonomy"
                [ngValue]="'FILTERED_PDF'"
                id="sel-{{dropdownList.length+2}}">
                  FILTERED PDF
              </option>
            </select>
          </div>
        </form>
      </div>
    </div>
    <div>
      
  </div>
  
  </modal-div>
<!-- (click)="onExportClick($event)" -->

  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-sm" id="cnfmBtnep" data-toggle="modal"
    [attr.data-target]="csvModalTarget" (click)="onExportClick($event)"
      [disabled]="selectedFileType===null" data-dismiss="modal">Confirm</button>
  </modal-div>
</app-modal>
<!-- Export Modal Ends -->

<div class="position-relative" style="height:100px" *ngIf="currentTab==='publish' && downloadLoader">
  <app-preloader [loaderText]="'Downloading..'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
</div>
<!-- Publish History Table Starts -->

<div id="exportPublishTable" class="col-12 p-0 overflow-auto">
  <app-data-table [showMenu]="true" class="w-100" [tableCategory]="'publish history'"
    [columnList]="listOfColumnPublishHistory" [dataSet]="publishHistoryList" [optionList]="optionList"
    [showLoader]="publishLoader" (clickedOption)="onOptionClicked($event)" *ngIf="currentTab==='publish'"
    [isSearchNeeded]="false">
  </app-data-table>
</div>
<!-- Publish History Table Ends -->

<!-- Export CSV Start -->
<app-modal [modalId]="'exportCSVModal'" [showCloseAlert]="false" [modalSize]="'small'" (closeEvent)="onCancel()" [showHelp]="false">
  <modal-div class="title-text" id="{{option}}title">
    Export Taxonomy - Choose Metadata
  </modal-div>
  <modal-div class="body-content export-csv-modal position-relative">
    <div class="d-flex align-items-center mb-2">
      <div class="mr-2">Choose the metadata which will appear in exported file</div>
       <div class="mr-2">
        <label class="mb-0 d-inline-flex align-items-center">
          <input type="checkbox" [checked]="isExcludeAssociation" (click)="toggleExclude()" class="mr-1" />
          <span class="text-nowrap">Exclude Associations</span>
        </label>
       </div>
      
      <button (click)="selectAlltoggle()" class="btn btn-sm btn-outline-primary text-nowrap px-1 ml-auto">{{selection}}</button>
    
    </div>  
    
    <!-- Dropdown container for Case -->
    <div (clickOutside)="showCaseDropDown = false" class="mb-4">
      <label for="caseMetaData" class="font-bold" id="caseMetaData">CASE</label>
      <button class="custom-select uf-custom-multiselect form-control text-left" (click)="showCaseDropDown = !showCaseDropDown">
        <span *ngIf="caseCheckedList.length <= 0">Select</span>
        <div class="selected-items">
          <div *ngFor="let selectedItem of caseCheckedList">
            <span>{{ selectedItem }}</span>
          </div>
        </div>
      </button>
      <div class="uf-custom-multiselect" *ngIf="showCaseDropDown"  style="overflow: auto;">
        <label *ngFor="let data of casefilteredMetadata">
          <input type="checkbox" [(ngModel)]="data.checked" (change)="getSelectedValue(data.checked, data.internal_name, caseCheckedList)" [disabled]="data.internal_name == 'human_coding_scheme' || data.internal_name == 'full_statement' || data.internal_name == 'title'"/>
          <span>{{ data.internal_name }}</span>
        </label>
      </div>
    </div>
    <!-- Dropdown container for Custom -->
    <div (clickOutside)="showCustomDropDown = false" class="multiselect-wrapper">
      <label for="customMetaData" class="font-bold" id="customMetaData">CUSTOM</label>
      <button class="custom-select uf-custom-multiselect form-control text-left" (click)="showCustomDropDown = !showCustomDropDown" 
      [attr.aria-expanded]="showCustomDropDown ? 'true' : 'false'"
      [attr.aria-controls]="'dropdown-list'"
      aria-haspopup="listbox"
      aria-label="Toggle multi-select options">
        <span *ngIf="customCheckedList.length <= 0">Select</span>
        <div class="selected-items">
          <div *ngFor="let selectedItem of customCheckedList" class="selected-item">
            <span>{{ selectedItem }}</span>
          </div>
        </div>
      </button>
      <div  id="dropdown-list" role="listbox" class="uf-custom-multiselect" aria-labelledby="multi-select-button" *ngIf="showCustomDropDown">
        <label *ngFor="let data of customfilteredMetadata" [attr.id]="'option-' + data.name">
          <input type="checkbox" [(ngModel)]="data.checked" (change)="getSelectedValue(data.checked, data.name, customCheckedList)" [attr.aria-checked]="data.checked ? 'true' : 'false'"
          [attr.tabindex]="showCustomDropDown ? '0' : '-1'"
          role="option"
          [attr.aria-selected]="data.checked ? 'true' : 'false'"
          [attr.aria-labelledby]="'option-' + data.name"/>
          <span>{{ data.name }}</span>
        </label>
      </div>
    </div>
  </modal-div>

  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-sm" id="cnfmBtnep" (click)="onCsvExportClick($event)"
      [disabled]="selectedFileType===null" data-dismiss="modal">Confirm</button>
  </modal-div>
</app-modal>
<!-- Export CSV END -->